import {apiSlice} from './apiSlice';

// Define a service using a base URL and expected endpoints
export const patientStatusApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatePatientStatus: builder.mutation({
      query: ({id, body}) => ({
        url: `patient_status/${id}/`,
        method: 'PUT',
        body
      }),
      invalidatesTags: ['Patient'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useUpdatePatientStatusMutation
} = patientStatusApi;
